export default "/images/vendor/flag-icon-css/flags/4x3/ck.svg?85e3a69fb3e37092626f0b1aa37febc0";